import { Currencies } from '@constants/enums';

// eslint-disable-next-line import/prefer-default-export
export const INITIAL_STATE: any = {
  id: '',
  entityBusiness: '',
  name: '',
  company: '',
  contact1: '',
  email: '',
  contact2: '',
  registration: '',
  accountNumber: '',
  identificationNumber: '',
  clabe: '',
  routingNumber: '',
  legalEntityName: '',
  country: '', // optional
  addressLine1: '',
  addressLine2: '', // optional
  currency: Currencies.MXN, // optional
  city: '',
  state: '', // optional
  postCode: '',
  taxId: '', // optional
  bankName: '',
  phoneNumber: '',
  documentType: '',
  personType: 'user',
};
